import Template from './ActivityNavigation.hbs';
import TaskGroupItem from 'views/pages/activities/show/sidebars/activityNavigation/item/Item'

export default class ActivityNavigation extends BaseView {

    /**
     * @param {Object} options options
     * @param {NavigationBarLinear} options.navigationBar linear navigation bar view
     */
    initialize({
        navigationBar,
    }) {

        this.$el.html(Template({}))

        this.model.task_groups.forEach((taskGroup) => {
            this.addChildView(new TaskGroupItem({
                model: taskGroup,
                activityModel: this.model,
                navigationBar,
            }), '.js-progress-holder')
        })

        // Scroll the sidebar so that the active task group is visible
        this.listenToOnce(Backbone.View.sidebar, 'sidebarIsOpen', () => {
            const activeItem = this.el.querySelector('[data-active=true]')
            activeItem?.scrollIntoView({ block: 'center' })
        })

    }

}
